import ActionButton from '@components/action-button/ActionButton';
import ContentPage from '@components/content-page/ContentPage';
import KolTemplate from '@components/kol-template/KolTemplate';
import BetPickLink from '@components/kol/bet-pick-link';
import LiveVideo from '@components/live-video/LiveVideo';
import Mp4Video from '@components/mp4-video/Mp4Video';
import QualtricsCom from '@components/qualtrics-com/QualtricsCom';
import PagePhotoAlbumBulk from '@components/photo-album/PhotoAlbum';
import PagePhotoAlbumAltText from '@components/photo-album/PhotoAlbumAltText';
import {
    AllupBetlineFragment,
    BadgesIconListFragment,
    ContentBlockFragment,
} from '@graphqlTypes/sitecore';
import { ComponentDataListFragment } from '@src/common/types';
import { createElement } from 'react';

const components: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
} = {
    PageGenericContentParagraphs: ContentPage,
    PageCallToActionButton: ActionButton,
    PageLiveStreamingVideo: LiveVideo,
    PageGenericVideo: Mp4Video,
    QualtricsSurveyComponent: QualtricsCom,
    PageBetpickLink: BetPickLink,
    PageKolLeaderboard: KolTemplate,
    PagePhotoAlbumBulk,
    PagePhotoAlbumAltText,
    default: () => <></>,
};

const DynamicComponent = ({
    componentDataList,
    className,
    currentPath,
    contentBlock,
    badgesIconData,
    AllUpData,
    updateShowChanges,
}: {
    componentDataList: ComponentDataListFragment;
    className?: string;
    currentPath: string;
    contentBlock: ContentBlockFragment;
    badgesIconData?: BadgesIconListFragment[] | [];
    AllUpData?: AllupBetlineFragment[];
    updateShowChanges?: (i: boolean) => void;
}) => {
    return componentDataList.map((data, index) => {
        if (!data) {
            return <></>;
        }
        const template = data.content?.template.name || 'default';
        const Component = createElement(components[template] || components.default, {
            key: index,
            content: data.content,
            className,
            currentPath,
            contentBlock,
            badgesIconData,
            AllUpData,
            updateShowChanges,
        });
        return Component;
    });
};

export default DynamicComponent;
